import React from 'react'
import Section from 'sparkol-web-component-library/src/components/section'
import CTAButtons from '../CTAButtons'

const CTAWrappedSection = props => {
  return <Section {...props} footer={<CTAButtons />} />
}

export default CTAWrappedSection
